const isLocalhost = window.location.hostname === 'localhost';
const host = isLocalhost ? 'localhost:8080' : '192.168.10.79:8080';
const protocol = window.location.protocol;

export const environment = {
  production: false,
  stage: 'local',
  backendUrl: `${protocol}//${host}/api`,
};
